import { render, staticRenderFns } from "./Recents.vue?vue&type=template&id=5d30375f&"
import script from "./Recents.vue?vue&type=script&lang=js&"
export * from "./Recents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports